import type { EditorSelectionRange, SelectionRequestMatch } from '@/types/aiWorkspace';

function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

function offsetToPosition(content: string, offset: number): { lineNumber: number; column: number } {
  const clamped = clamp(offset, 0, content.length);

  let lineNumber = 1;
  let lastLineStart = 0;

  for (let i = 0; i < clamped; i++) {
    if (content[i] === '\n') {
      lineNumber += 1;
      lastLineStart = i + 1;
    }
  }

  return {
    lineNumber,
    column: clamped - lastLineStart + 1,
  };
}

export function selectionRangeKey(range: EditorSelectionRange | null): string | null {
  if (!range) return null;
  return `${range.startLineNumber}:${range.startColumn}-${range.endLineNumber}:${range.endColumn}`;
}

export function findSelectionRangeByText(
  content: string,
  text: string,
  match: SelectionRequestMatch = 'last'
): EditorSelectionRange | null {
  if (!text) return null;

  const index = match === 'first' ? content.indexOf(text) : content.lastIndexOf(text);
  if (index === -1) return null;

  const start = offsetToPosition(content, index);
  const end = offsetToPosition(content, index + text.length);

  return {
    startLineNumber: start.lineNumber,
    startColumn: start.column,
    endLineNumber: end.lineNumber,
    endColumn: end.column,
  };
}

